import React, { useState } from 'react';
import { Building2, Search, PenTool, CalendarCheck, Settings, Award, Gift, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const blocks = [{
    title: 'MÓDULO I: FUNDAMENTOS DE LAS ORGANIZACIONES Y LA GESTIÓN',
    icon: <Building2 className="text-blue-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-225" />,
    color: 'bg-blue-100',
    items: ['Qué es una organización', 'Importancia de las organizaciones en la sociedad', 'Organización como sistema', 'Elementos que componen una organización', 'Objetivos organizacionales', 'Tipos de organizaciones', 'Estructura organizacional', 'Roles dentro de una organización', 'Cultura organizacional', 'Procesos organizacionales']
  }, {
    title: 'MÓDULO II: DIAGNÓSTICO ORGANIZACIONAL',
    icon: <Search className="text-green-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-226" />,
    color: 'bg-green-100',
    items: ['Qué es un diagnóstico organizacional', 'Importancia del análisis organizacional', 'Identificación de problemas estructurales', 'Problemas de gestión y coordinación', 'Problemas de recursos y comunicación', 'Matriz FODA aplicada a organizaciones', 'Análisis del entorno institucional', 'Entorno económico, social y tecnológico', 'Identificación de oportunidades de mejora', 'Priorización estratégica de problemas']
  }, {
    title: 'MÓDULO III: DISEÑO DE PROYECTOS ORGANIZACIONALES',
    icon: <PenTool className="text-amber-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-227" />,
    color: 'bg-amber-100',
    items: ['Concepto de proyecto organizacional', 'Tipos de proyectos en organizaciones', 'Identificación del problema organizacional', 'Situación actual y situación deseada', 'Formulación del proyecto', 'Justificación del proyecto', 'Objetivo general y objetivos específicos', 'Beneficiarios directos e indirectos', 'Impacto esperado del proyecto']
  }, {
    title: 'MÓDULO IV: PLANIFICACIÓN Y GESTIÓN DE PROYECTOS',
    icon: <CalendarCheck className="text-red-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-228" />,
    color: 'bg-red-100',
    items: ['Importancia de la planificación estratégica', 'Etapas de un proyecto organizacional', 'Plan de actividades', 'Organización de tareas', 'Cronograma del proyecto', 'Gestión del tiempo', 'Diagramas de planificación', 'Recursos humanos del proyecto', 'Recursos materiales y tecnológicos', 'Presupuesto y estimación de costos']
  }, {
    title: 'MÓDULO V: IMPLEMENTACIÓN Y GESTIÓN DEL PROYECTO',
    icon: <Settings className="text-purple-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-229" />,
    color: 'bg-purple-100',
    items: ['Puesta en marcha del proyecto', 'Organización del equipo de trabajo', 'Asignación de responsabilidades', 'Coordinación de actividades', 'Comunicación organizacional', 'Resolución de conflictos', 'Seguimiento del proyecto', 'Control de avances', 'Gestión de problemas y dificultades']
  }, {
    title: 'MÓDULO VI: EVALUACIÓN Y PRESENTACIÓN DE PROYECTOS',
    icon: <Award className="text-orange-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-230" />,
    color: 'bg-orange-100',
    items: ['Evaluación de proyectos organizacionales', 'Indicadores de evaluación', 'Impacto organizacional', 'Evaluación de resultados', 'Evaluación cualitativa y cuantitativa', 'Elaboración de informes finales', 'Redacción profesional del proyecto', 'Presentación oral del proyecto', 'Defensa del trabajo final'],
    note: 'Además incluye un proyecto organizacional completo desarrollado paso a paso, desde el diagnóstico inicial hasta la evaluación final.'
  }, {
    title: 'BONOS INCLUIDOS',
    icon: <Gift className="text-pink-500 w-5 h-5 sm:w-6 sm:h-6" data-id="element-231" />,
    color: 'bg-pink-100',
    items: ['Banco Profesional de Proyectos Organizacionales', 'Planificación Anual Lista', 'Orientaciones pedagógicas', 'Sistema de evaluación completo']
  }];
  return <section id="que-incluye" className="py-6 sm:py-16 bg-white relative overflow-hidden" data-id="element-232">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-233">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-blue-600 rounded-full blur-3xl" data-id="element-234"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-purple-600 rounded-full blur-3xl" data-id="element-235"></div>
      </div>

      <div className="max-w-4xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-236">
        <div className="text-center mb-5 sm:mb-12" data-id="element-237">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-238">
            ¿Qué incluye el{' '}
            <span className="text-[#f59e0b]" data-id="element-239">
              KIT COMPLETO PROYECTO ORGANIZACIONAL
            </span>
            ?
          </h2>
        </div>

        <div className="flex flex-col gap-2 sm:gap-4 mb-6 sm:mb-12" data-id="element-240">
          {blocks.map((block, index) => {
          const isOpen = openIndex === index;
          const isBonus = index === blocks.length - 1;
          return <div key={index} className={`bg-gray-50 border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 shadow-sm ${isOpen ? 'ring-2 ring-[#f59e0b] ring-opacity-50' : 'hover:border-gray-300'}`} data-id="element-241">
                <button onClick={() => toggleAccordion(index)} className="w-full flex items-center justify-between p-3 sm:p-5 text-left focus:outline-none" data-id="element-242">
                  <div className="flex items-center gap-2 sm:gap-4" data-id="element-243">
                    <div className={`${block.color} w-8 h-8 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-244">
                      {block.icon}
                    </div>
                    <h3 className="text-[11px] sm:text-base font-bold text-gray-900" data-id="element-245">
                      {block.title}
                    </h3>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-246" />
                </button>

                <AnimatePresence data-id="element-247">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-248">
                      <div className="px-4 sm:px-5 pb-4 sm:pb-5 pt-0 border-t border-gray-100" data-id="element-249">
                        {isBonus ? <div className="flex flex-wrap gap-2 sm:gap-3 mt-4" data-id="element-250">
                            {block.items.map((item, i) => <span key={i} className="bg-white border border-[#fcd34d] text-gray-800 text-xs sm:text-sm px-3 py-1 rounded-full font-medium shadow-sm" data-id="element-251">
                                {item}
                              </span>)}
                          </div> : <>
                            <ul className="space-y-2 mt-4" data-id="element-252">
                              {block.items.map((item, i) => <li key={i} className="text-gray-600 text-xs sm:text-sm flex items-start" data-id="element-253">
                                  <span className="mr-2 text-[#f59e0b] mt-0.5" data-id="element-254">
                                    •
                                  </span>
                                  <span data-id="element-255">{item}</span>
                                </li>)}
                            </ul>
                            {block.note && <div className="mt-4 p-3 bg-[#fef3c7] rounded-lg border border-[#fcd34d]" data-id="element-256">
                                <p className="text-xs sm:text-sm text-gray-800 font-medium" data-id="element-257">
                                  {block.note}
                                </p>
                              </div>}
                          </>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-258">
          <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-[#16a34a] hover:bg-green-700 text-white text-xs sm:text-lg font-bold py-2.5 sm:py-4 px-5 sm:px-10 rounded-full shadow-lg transition-all transform hover:scale-105" data-id="element-259">
            📚 ¡Quiero organizar mi año ahora!
          </button>
        </div>
      </div>
    </section>;
}